import { render, staticRenderFns } from "./header-search-secondary.vue?vue&type=template&id=9927b1c6&scoped=true"
import script from "./header-search-secondary.vue?vue&type=script&lang=js"
export * from "./header-search-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9927b1c6",
  null
  
)

export default component.exports